import React, { useState, useEffect, useRef } from 'react'
import CommonSelect from './commonSelect';
import {DistrictOptions } from '../../../../core/data/json/apmc';
import { formFieldDataP1 } from '../../../../core/data/json/DistrictAPMC';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getExistedSchemesAplication, queryFormApplication, submitAnnexureOne, submitAnnexureUpdate, submitApmcFiles, updateField } from '../../../auth/services/privateapicalling';
import { Link } from 'react-router-dom';
import SingleView from './SingleView';
import { toast,ToastContainer } from "react-toastify";
import ActionButtons from './ActionButtons';
import { roleOptions } from '../../../../core/data/json/role';

 
interface APMCp1Props {
  setExistData:any;
  token:string
  onNext: () => void;
  formData: any;
  handleFileChange: (e: React.ChangeEvent<HTMLInputElement> , documentName: string) => Promise<string>;
  hanldeFileInputChange:(e: React.ChangeEvent<HTMLInputElement> , documentName: string) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handlePreviewFile: (fileData: any) => void;
  districtOptions: any[];
  talukaOptions: any[];
  apmcOptions: any[];
  editingIndex: number | null;
  setEditingIndex: (index: number | null) => void;
  editFieldValues: { [key: string]: any };
  handleEditChange: (name: string, value: any) => void;
  editFiles: { [key: string]: File | null };
  handleEditFileChange: (name: string, file: File | null) => void;
  editComment: string;
  setEditComment: (comment: string) => void;
  updatedFields:any,

  existData:any,
  userDetail:any;
  applicationId:any;
  setUpdatedFields:any
  getExistedApplication :() => void;
  validationErrors: { [key: string]: boolean };
  setValidationErrors: (errors: { [key: string]: boolean } | ((prev: { [key: string]: boolean }) => { [key: string]: boolean })) => void;
  isValidationActive: boolean;
  setIsValidationActive: (active: boolean) => void;
}

const DistP1 = ({
  setExistData,
  token,
  onNext,
  formData,
  handleFileChange,
  hanldeFileInputChange,
  handleInputChange,
  handlePreviewFile,
  districtOptions,
  talukaOptions,
  apmcOptions,
  editingIndex,
  setEditingIndex,
  updatedFields,
  existData,
  userDetail,
  setUpdatedFields,
  applicationId,
  getExistedApplication,
  validationErrors,
  setValidationErrors,
  isValidationActive,
  setIsValidationActive,
}: APMCp1Props) => {

//---------------------------------Validation----------------------------------

const validateActionButtons = () => {
  const errors: { [key: string]: boolean } = {};
  
  // Check each field that requires action
  formFieldDataP1.forEach((item, index) => {
    // Skip fields that don't need validation
    if (item.fieldNo === '01.' || item.fieldNo === '02.' ) {
      return;
    }

    const fieldAction = fieldActions[index];
  const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;


// Check if field was already submitted in existData
let isFieldSubmittedInExistData = false;

item.response.forEach((r) => {
  const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureOne;
  const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];
  let lastRoleTx = null;

  // Skip resubmission check if status is pendingAtHigherAuthorityApproval
  const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';

  if (shouldCheckResubmission && reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
    // If resubmitted field, only set lastRoleTx if the last transaction is for this role
    if (transactions.length > 0) {
      const lastTx = transactions[transactions.length - 1];
      if (lastTx.transactionBy === roleIdentifier) {
        lastRoleTx = lastTx;
      }
    }
  } else {
    // Not a resubmitted field: filter by role as before
    lastRoleTx = transactions.filter(
      (tx) => tx.transactionBy === roleIdentifier
    ).pop();
  }

  if (lastRoleTx) {
    if (lastRoleTx.isVerified === true || 
        lastRoleTx.isUpdated === true || 
        (lastRoleTx.comment && lastRoleTx.comment.trim() !== '')) {
      isFieldSubmittedInExistData = true;
    }
  }
});

    // Field has error if it's not submitted and has no current action
    if (!isFieldSubmittedInExistData && !fieldAction?.submitted) {
      errors[`field_${index}`] = true;
    }
  });

  setValidationErrors(errors);
  return Object.keys(errors).length === 0;
};
  
//----------------------------------Handle Select Changes----------------------------------
  
  const handleCommonSelectChange = (option: { value: string; label: string } | null, name?: string) => {
    if (!name) return;
    let updates: any = { [name]: option ? option.value : "" };
    Object.entries(updates).forEach(([key, value]) => {
      handleInputChange({ target: { name: key, value } } as any);
    });
  };

  const [showLogOverlay, setShowLogOverlay] = useState(false);
  const [transactionData, setTransactionData] = useState([]);



   const tempgetExistedApplication = async () => {
     try {
      
          const response = await getExistedSchemesAplication(token, applicationId, existData.scheme.id);

          if (response?.success) {
           
             setExistData(response?.data);
          }
        } catch (error) {
       
        }
      }

  const handleViewLogClick = (fieldKeys: string[] | string) => {
   
    const keys = Array.isArray(fieldKeys) ? fieldKeys : [fieldKeys];
   
    
    const transactionData = keys.map(key => ({
      key,
      data: existData.annexureOne?.[key]?.transaction || []
    }));

 
    setTransactionData(transactionData)

    setLogFieldKey(keys.join(", "));
 
    setShowLogOverlay(true);
  };

  const handleCloseOverlay = () => {
    setShowLogOverlay(false);
  };
 
  const roleIdentifier = userDetail.Role.Role_Identifier;

//----------------------------------Validation state----------------------------------
  const [touched, setTouched] = useState<{ [key: string]: boolean }>({});
  const [showErrors, setShowErrors] = useState(false);
  
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  
  // Validation logic for each field
  const validate = () => {
    const errors: { [key: string]: string } = {};
    if (!formData.district) errors.district = "District is required.";
    if (!formData.taluka) errors.taluka = "Taluka is required.";
    if (!formData.APMC) errors.APMC = "APMC is required.";
    if (!formData.district2) errors.district2 = "Category district is required.";
    if (!formData.categoryDoc) errors.categoryDoc = "Category document is required.";
    if (!formData.scheme) errors.scheme = "Scheme is required.";
    if (!formData.purpose) errors.purpose = "Purpose is required.";
    if (!formData.projectPlan1) errors.projectPlan1 = "Project plan is required.";
    if (!formData.projectPlan2) errors.projectPlan2 = "Project estimate is required.";
    if (!formData.percentage && formData.percentage !== 0) errors.percentage = "Percentage is required.";
    if (!formData.SORDoc) errors.SORDoc = "SOR document is required.";
    if (!formData.toolstDoc) errors.toolstDoc = "Tools document is required.";
    if (!formData.PWDDoc) errors.PWDDoc = "PWD document is required.";
    if (!formData.committeeName || formData.committeeName.trim() === "") errors.committeeName = "Committee name is required.";
    if (!formData.construction) errors.construction = "Please select Yes or No.";
    return errors;
  };

  const errors = validate();

//----------------------------------Mark input as touched on blur----------------------------------
  const handleBlur = (e: React.FocusEvent<HTMLInputElement | HTMLSelectElement>) => {
    setTouched(prev => ({ ...prev, [e.target.name]: true }));
  };

//----------------------------------Handle Changes----------------------------------

const handleNextClick = async() => {
  // First validate action buttons
   if(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"&&roleIdentifier===existData?.role&&existData?.appStatusLevel!=="hoclerkAfterApproveAction"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ")
 { const isValid = validateActionButtons();
  setIsValidationActive(true);

  if (!isValid) {
    // Scroll to first error field
    const firstErrorField = Object.keys(validationErrors)[0];
    if (firstErrorField) {
      const fieldIndex = firstErrorField.replace('field_', '');
      const element = document.getElementById(`actionButtons_${fieldIndex}`);
      if (element) {
        element.scrollIntoView({ 
          behavior: 'smooth', 
          block: 'center' 
        });
      }
    }
    
    toast.error("Please complete all required actions before proceeding", {
      position: "top-right"
    });
    return;
  }
}
  // Reset validation state on successful validation
  setIsValidationActive(false);
  setValidationErrors({});
    setShowErrors(true);
    try{
  
      onNext()
    
  } catch(error) {
   
  }
};

//----------------------------------Percentage(0-100)----------------------------------
  const handlePercentageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const{name, value} = e.target;

    if (!/^\d{0,3}(\.\d{0,2})?$|^\d+\.$/.test(value)) return;

    const num = parseFloat(value);
    if (!isNaN(num) && num > 100) return;

    handleInputChange({
      target: {
        name, value
      },
    } as any);
  };

  const handlePercentageBlur = () => {
    const value = formData.percentOfProjCostEligible;
    if (value && /^\d+\.?$/.test(value)) {
      const formatted = parseFloat(value).toFixed(2);
      handleInputChange({
        target: { name: "percentOfProjCostEligible", value: formatted },
      } as any);
    }
  };

  // State for tracking field actions
  const [fieldActions, setFieldActions] = useState<{ [key: number]: {
    verified: boolean;
    updated: boolean;
    comment: string;
    updateData: any;
    submitted?: boolean;
  } }>({});

  

  //----------------------------- Div for the click of View Log-------------------------
  const [logFieldKey, setLogFieldKey] = useState<string | null>(null);
 

  // Updated handlers for field actions
  const handleVerifiedChange = (fieldIndex: number) => {
    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: !prev[fieldIndex]?.verified,
        updated: prev[fieldIndex]?.updated || false,
        comment: prev[fieldIndex]?.comment || "",
        updateData: prev[fieldIndex]?.updateData || {},
        submitted: prev[fieldIndex]?.submitted || false  
      }
    }));
    // alert("Click on Submit")
    toast.warning("Click on Submit",{position:"top-right"})
  };

  const handleCommentChange = (fieldIndex: number, comment: string) => {
 

    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: prev[fieldIndex]?.updated || false,
        comment: comment,
        updateData: prev[fieldIndex]?.updateData || {}
      }
    }));
  };

  function buildResponseMap(jsonData) {
    return jsonData
      .flatMap(field => field.response)
      .reduce((acc, resp) => {
        acc[resp.responseVal] = resp.responseName;
        return acc;
      }, {});
  }
  const responseMap = buildResponseMap(formFieldDataP1);

  const handleUpdateData = (fieldIndex: number, updateData: any) => {
 
    // Only set updated to true if there's actual data in updateData
    const hasActualData = Object.values(updateData).some(value => 
      value !== null && value !== undefined && value !== ""
    );
    
  

    setFieldActions(prev => ({
      ...prev,
      [fieldIndex]: {
        ...prev[fieldIndex],
        verified: prev[fieldIndex]?.verified || false,
        updated: hasActualData, // Only true if there's actual data
        comment: prev[fieldIndex]?.comment || "",
        updateData: updateData,
        submitted: prev[fieldIndex]?.submitted || false
      }
    }));
  };
   
  const handleUpdateSubmit = async (index: number, responses: any[]) => {
  

   
    const fieldAction = fieldActions[index];
  

    if (!fieldAction) {
     
      return;
    }

   
    const comment = fieldAction.comment;
    const oldValue: any[] = [];
    const newValue: any[] = [];
  let isFieldUpdated = false;

    const field = responses.find(res => res?.fieldName)?.fieldName ? 
                  responses.find(res => res?.fieldName)?.fieldName : 
                  responses.find(res => res.responseVal)?.responseVal;

              

     if(Object.keys(updatedFields).length > 0){

    isFieldUpdated=true;
 
    Object.entries(fieldAction.updateData).forEach(([fieldKey, updatedVal]: any) => {
      const fieldDataArray = existData?.annexureOne?.[field]?.data;
     
      if (!Array.isArray(fieldDataArray)) return;

      let matched;

      if (updatedVal?.docId && updatedVal?.documentName) {
        
        matched = fieldDataArray.find(
          (item: any) =>
            item?.documentName === updatedVal.documentName && item?.docId !== updatedVal.docId
        );

    

        if (matched) {
          oldValue.push({
            fieldValue: matched?.docId || "",
            fieldName: matched?.documentName,
            fileName: matched?.fileName,
            fieldType: "doc"
          });
        }
        else{
           oldValue.push({
            fieldValue: matched?.docId || "",
            fieldName: updatedVal?.documentName,
            fileName: matched?.fileName,
            fieldType: "doc"
          });
        }

        newValue.push({
          fieldValue: updatedVal?.docId,
          fieldName: updatedVal?.documentName,
          fileName:updatedVal?.fileName,
          fieldType: "doc"
        });
      } else {
        matched = fieldDataArray.find(
          (item: any) => item?.fieldName === fieldKey
        );

        if (matched) {
          oldValue.push({
            fieldValue: matched?.value || "",
            fieldName: matched?.fieldName,
            fieldType: "string"
          });
        }

        newValue.push({
          fieldValue: updatedVal,
          fieldName: fieldKey,
          fieldType: "string"
        });
      }
    });
  }
   if(comment.trim()=="" &&isFieldUpdated) 
    {
      toast.warn('comment is mandatory while updation',{position:"top-right"});
      return;
    }
    const transaction = [{
      oldValue,
      newValue,
      transactionBy: roleIdentifier,
      status: existData.status,
      appStatusLevel: existData.appStatusLevel,
    
    }];

    const payload = {
      couchId: existData?.applicationDataId,
      fieldUpdated: field,
      applicationType:"scheme",
      isUpdated:isFieldUpdated,
      isVerified: isFieldUpdated?false:fieldAction.verified,
      comment: comment,
      annexureUpdated: "annexureOne",
      [`${field}`]: {
        transaction
      }
    };

    

    try {
      const submitTransaction = await updateField(payload, token);
     

      if (submitTransaction?.result?.ok) {
        setEditingIndex(null);
       toast.success(
                 <>
                   Field Transaction submitted successfully <br />
                   ફીલ્ડ સફળતાપૂર્વક સબમિટ કરવામાં આવ્યું
                 </>,
                 {
                   position: "top-right",
               
                 }
               );
        
        // Update the field action to mark as submitted instead of clearing it
        setFieldActions(prev => ({
          ...prev,
          [index]: {
            ...prev[index],
            submitted: true  // Add this flag to indicate submission is complete
          }
        }));

          // Clear validation error for this field
        setValidationErrors(prev => {
          const updated = { ...prev };
          delete updated[`field_${index}`];
          return updated;
        });
        
        setUpdatedFields({})
        tempgetExistedApplication();
      } else {
     
      }
    } catch (error) {
     
    }
  };

  useEffect(() => {
    if (showLogOverlay) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [showLogOverlay]);

// Updated ActionButtons component


// Rest of your component functions remain the same...
const selectFn = (fieldName: string , docName:string) => {
  let selectedValue = null;
  selectedValue = { value: formData[fieldName], label: formData[fieldName] };
  let  options = [ selectedValue];

  const value = existData?.annexureOne?.[fieldName]?.data.find(data=>data.fieldName?.toLowerCase() == docName?.toLowerCase())?.value

  return (
    <div className="p-2 w-100 text-muted border rounded bg-light">
      {value}
    </div>
  );
};

const inputFn =(fieldName: string)=>{
  return(
    <input
      type='text'
      className=" p-2  form-control"
      placeholder={`Enter ${fieldName}`}
      name={fieldName}
      value={formData[fieldName] || ""}
      onChange={handleInputChange}
      onBlur={handleBlur}
      disabled={ true}
    />
  )
}
const purposeinputFn = (fieldName: string) => {
  const data = formData[fieldName] || [];
  
  return (
    <div className="space-y-2">
      {data.map((item, index) => (
         <div key={item.id || index} className="border rounded p-3 bg-gray-50">
          <div className="mb-2">
            <span className="font-medium text-gray-700">Name: </span>
            <span>{item.name}</span>
          </div>
          <div>
            <span className="font-medium text-gray-700">Cost: </span>
            <span>₹{item.cost.toLocaleString()}</span>
          </div>
        </div>
      ))}
    </div>
  );
};

const radioFn = (fieldName: string, docName: string) => {
  const value = existData?.annexureOne?.[fieldName]?.data.find(
    (data) => data.fieldName?.toLowerCase() === docName?.toLowerCase()
  )?.value;

  return (
    <div className="d-flex justify-start gap-2">
      <input
        type="radio"
        name={"readonly-" + fieldName}
        value={value}
        checked={value === "yes"}
        disabled={true}
      />{" "}Yes
      <input
        type="radio"
        name={"readonly-" + fieldName}
        value={value}
        checked={value === "no"}
        disabled={true}
      />{" "}No
    </div>
  );
};

const fileFn = (response:any) => (
  <>
    <input
      className="form-control"
      type="file"
      onChange={(e) => {
        hanldeFileInputChange(e, response);
      }}
      name={response}
      accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg"
      id={response}
    />

    {/* Prevent long filenames from overflowing: truncate with ellipsis */}
    {formData[response] && (
      <div className="w-100" style={{ overflow: 'hidden' }}>
        <p
          className="mb-0"
          style={{
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          }}
          title={formData[response]?.fileName}
        >
          Uploaded: {formData[response]?.fileName}
        </p>
      </div>
    )}
  </>
);

const fileButtonFn = (fieldName , docName) => {
  const docData = existData?.annexureOne?.[fieldName];
  // guard against missing data array
  const docId = docData?.data?.find(data=>data.documentName == docName)?.docId;
 

  // Only show button when docId is neither null nor undefined nor an empty string
  const hasValidDocId = docId !== null && docId !== undefined && String(docId).trim() !== "";

  return (
    hasValidDocId &&
    <Link
      to="#"
      data-bs-toggle="modal"
      data-inert={true}
      data-bs-target="#apmc_modal"
      className="btn btn-outline-info w-100 align-items-center"
      onClick={() => {
        setSelectedDocId(docId);
      }}
    >
      <i className="ti ti-eye"></i> View Document
    </Link>
  );
};
const displayAllYards = () => {
  const mainYardData = existData?.mainYard || [];
  const subYardData = existData?.subYard || [];
  const allYards = [...mainYardData, ...subYardData];
  
  // Group purposes by yard name
  const groupedByYard = allYards.reduce((acc, item) => {
    if (!acc[item.yard]) {
      acc[item.yard] = [];
    }
    acc[item.yard].push(item.purpose);
    return acc;
  }, {});
  
 return (
  <div className="space-y-2">
    {Object.entries(groupedByYard).map(([yardName, purposes], index) => (
      <div key={index} className="border rounded text-sm">
        <div className="px-2 py-1.5 font-semibold" style={{backgroundColor:"#CCE3FF"}}>
          {yardName}
        </div>
        <div className="px-2 py-1 bg-white">
          {Array.isArray(purposes) && purposes.map((purpose, pIndex) => (
            <div key={pIndex} className="text-gray-700 py-0.5 pl-2">
              • {purpose}
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
);
};
const percentageFn = (fieldName: string) => (
  <input
    className="form-control"
    type="text"
    inputMode="decimal"
    name={fieldName}
    placeholder="0 - 100"
    value={formData[fieldName] ?? ""}
    onChange={handlePercentageChange}
    onBlur={handlePercentageBlur}
    disabled={ true}
  />
);
 const handleDirector = async (fieldsToUpdate: any[]) => {
    try {
      if (!fieldsToUpdate || fieldsToUpdate.length === 0) return;
  //  setSubmitLoading(true);
      const payload = {
        couchId: existData?.applicationDataId,
        applicationType: "scheme",
        fieldsToUpdate: fieldsToUpdate
      };

      

      // Call the API
      const response = await queryFormApplication(payload, token);

      if (response?.dbResult?.ok) {
       toast.success(
          <>
            Field updated  successfully <br />
        ક્ષેત્ર સફળતાપૂર્વક અપડેટ થયું
          </>,
          {
            position: "top-right",
         
          }
        ); 
      getExistedApplication();
      } else {
      
      }
        
    } catch (error) {
    
     
    } finally {
    // setSubmitLoading(false)
    }
  };


   useEffect(() => {
  
  
      if (!existData || !existData.annexureOne || !formFieldDataP1) return;
  
      const newVerified: { [key: number]: boolean } = {};
      const newUpdatedIndexes: number[] = [];
      const newComments: { [key: string]: string } = {};
  
      formFieldDataP1.forEach((item, index) => {
        let isVerifiedForRole = false;
        let isUpdatedForRole = false;
        let commentForRole: string | null = null;
  
        item.response.forEach((r) => {
          const reSubmittedFieldsData = existData?.apmcSchemeTransaction?.rejectedFields?.rejectedFieldsData?.annexureOne;
          const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];
          let lastRoleTx = null;
          const shouldCheckResubmission = existData?.appStatusLevel !== 'pendingAtHigherAuthorityApproval';
          if (shouldCheckResubmission&&reSubmittedFieldsData && Object.prototype.hasOwnProperty.call(reSubmittedFieldsData, r.fieldName)) {
            // If resubmitted field, only set lastRoleTx if the last transaction is for this role
            if (transactions.length > 0) {
              const lastTx = transactions[transactions.length - 1];
              if (lastTx.transactionBy === roleIdentifier) {
                lastRoleTx = lastTx;
              }
            }
          } else {
            // Not a resubmitted field: filter by role as before
            lastRoleTx = transactions.filter(
              (tx) => tx.transactionBy === roleIdentifier
            ).pop();
          }
  
          if (lastRoleTx) {
            if (lastRoleTx.isVerified === true) {
              isVerifiedForRole = true;
            }
            if (lastRoleTx.isUpdated === true) {
              isUpdatedForRole = true;
            }
          if (lastRoleTx.comment) {
  const shouldAssignComment = 
    existData.appStatusLevel === "pendingAtHigherAuthorityLevel"
      ? lastRoleTx.appStatusLevel === "pendingAtHigherAuthorityLevel"
      : true;
  
  if (shouldAssignComment) {
    commentForRole = lastRoleTx.comment;
  }
}  
          }
        });
  
        if (isVerifiedForRole) {
          newVerified[index] = true;
        }
        if (isUpdatedForRole) {
          newUpdatedIndexes.push(index);
        }
        if (commentForRole) {
          newComments[item.fieldName] = commentForRole;
        }
          setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          verified: newVerified[index] || false,
          updated: prev[index]?.updated || false,
          comment: newComments[item?.fieldName] || "",
          updateData: prev[index]?.updateData || {},
          submitted:(newVerified[index]===true)
         
        }
      }));
  
      });
  
      
    }, [existData, roleIdentifier]);
  // ensure this runs once when required data becomes available
  const autoVerifyDoneRef = useRef(false);

  useEffect(() => {
    // avoid running multiple times
    if (autoVerifyDoneRef.current) return;

    // Wait until we have the data and role info
    if (!existData || !existData.annexureOne || !formFieldDataP1 || !roleIdentifier) return;

    const isDirector = roleIdentifier === "DT";
    const isDistrictRegistrar = roleIdentifier === "Dr";
    if (!isDirector && !isDistrictRegistrar) return;

    const newVerified: { [key: number]: boolean } = {};
    const verifiedFieldsToUpdate: any[] = [];

    // Director should auto-verify fields verified by Deputy Director (DY)
    // District Registrar should auto-verify fields verified by Committee (COM)
    const verifierRoleIdentifier = isDirector ? "DY" : "COM";

    formFieldDataP1.forEach((item, index) => {
      let isVerifiedByPrevious = false;

      item.response.forEach((r) => {
        const transactions = existData.annexureOne?.[r.fieldName]?.transaction || [];

        const prevVerified = transactions.some(
          (tx) => tx.transactionBy === verifierRoleIdentifier && tx.isVerified === true
        );

        if (prevVerified) {
          isVerifiedByPrevious = true;
        }
      });

      if (isVerifiedByPrevious) {
        newVerified[index] = true;

        verifiedFieldsToUpdate.push({
          fieldUpdated: item.fieldName,
          annexureUpdated: "annexureOne",
          newTransaction: {
            transactionBy: userDetail?.Role?.Role_Identifier,
            status: "pending",
            appStatusLevel: existData.appStatusLevel,
            newValue: []
          },
          isVerified: true,
          isUpdated: false,
          comment: ""
        });
      }

      setFieldActions(prev => ({
        ...prev,
        [index]: {
          ...prev[index],
          verified: newVerified[index] || false,
          updated: prev[index]?.updated || false,
          comment: prev[index]?.comment || "",
          updateData: prev[index]?.updateData || {},
          submitted: true
        }
      }));
    });

    if (verifiedFieldsToUpdate.length > 0) {
      handleDirector(verifiedFieldsToUpdate);
    }

    // mark done so it doesn't re-run
    autoVerifyDoneRef.current = true;

    // Run when the data or role become available; but only once because of the ref
  }, [existData, roleIdentifier, formFieldDataP1]); 

  return (
    <>
    <div className='w-100 d-flex align-items-end justify-content-end px-5'>
      <div className="w-100">
        <div className='d-flex flex-column text-nightblue align-items-center justify-content-center'>
          <div id='table' className='w-100 overflow-hidden border border-secondary bg-white rounded mb-5'>
            <div id='head' className='d-flex w-100 rounded-top border-secondary' style={{backgroundColor:"#CCE3FF"}}>
                <h4 className='col-1 d-flex justify-content-center align-items-center'>S.No.</h4>
                <h4 className='col-4 p-2 justify-content-center d-flex align-items-center border-start border-end border-secondary'>પ્રશ્ન(Field)</h4>
                <div className="d-flex col-7">
    <h4
     className={`p-2 justify-content-center d-flex align-items-center border-end border-secondary ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}

    >
      જવાબ (Response)
    </h4>

    {(existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ")) && (
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center border-end border-secondary">
        ક્રિયા (Action)
      </h4>
    )}
      <h4 className="col-4 p-2 justify-content-center d-flex align-items-center  border-secondary">
                  Change History
                </h4>
  </div>
              
            </div>

            {formFieldDataP1 && formFieldDataP1.length > 0 &&
            formFieldDataP1.map((item,index)=>{
              return(
                <React.Fragment key={index}>
                 <div className={`d-flex border-top border-secondary ${(() => {
                      const fieldName = item.response.find((r) => r?.fieldName)?.fieldName;
                      if (!fieldName) return '';
                      
                      const annexureField = existData?.annexureOne?.[fieldName];
                      const hasSubmittedUpdates = annexureField?.transaction?.some(
                        (txn) => (txn?.isUpdated === true && txn?.transactionBy == roleIdentifier)
                        // || txn?.comment.trim() !== ""
                        //For comment to show
                      ) ?? false;
                      
                      return hasSubmittedUpdates ? 'bg-body-tertiary' : ''; // bg-body-tertiary
                    })()}`}>
                    <h4 className='col-1  d-flex align-items-center justify-content-center'>{item.fieldNo}</h4>
                    <div className='col-4 border-start border-end border-secondary  d-flex align-items-center justify-content-start p-2'>
                        <p>{item.fieldVal}*</p>
                    </div>
                    <div className='col-7 d-flex'>
                      <div className={`col-4 d-flex border-end border-secondary flex-column p-2 gap-2 align-items-center justify-content-center ${
  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))
    ? "col-4"
    : "col-8"
}`}>
                        {item.response.map((newObj, indx) => {
                          if(!newObj.roles.includes(roleIdentifier)){
                            return
                          }
                          const fieldName = newObj?.fieldName ;
                          const docName = newObj.responseVal;
                          const inputKey = `${index}_${indx}`;
                          const divVal =
                          newObj.responseType === "select" ? selectFn(fieldName , docName) :
                          newObj.responseType === "input" ? inputFn(docName) :
                          newObj.responseType === "purposeinput" ? purposeinputFn(docName) :
                          newObj.responseType === "selectyard" ? displayAllYards() :
                          newObj.responseType === "radio" ? radioFn(fieldName , docName) :
                          newObj.responseType === "percentage" ? percentageFn(fieldName) :
                          newObj.responseType === "button" ? fileButtonFn(fieldName , docName) :
                          newObj.responseType === "file" ? fileFn(fieldName) :
                          null;

                          return (
                            <div className='w-75' key={inputKey}>
                              {divVal}
                              {fieldName === "projectPlan1" && (
                                <span className="text-info small mt-1">Project Plan</span>
                              )}
                              {fieldName === "projectPlan2" && (
                                <span className="text-info small mt-1">Estimation Cost</span>
                              )}
                            </div>
                          );
                        })}
                      </div>
               {  (existData?.status !== "approve" && existData?.role===roleIdentifier&&(existData?.appStatusLevel!=="returnToDClerkForwardingToHO"&&existData?.appStatusLevel!=="returnToDClerkForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmission"&&existData?.appStatusLevel!=="returnToDClerkAfterApmcForwardingToHOResubmissionAfterHARQ"))  &&    <div className='col-4 d-flex p-2 gap-2 border-end border-secondary flex-column flex-lg-row align-items-center justify-content-center'>
                        {!(
                          item.fieldNo === '01.' ||
                          item.fieldNo === '02.'
                         
                        ) && (
                          <ActionButtons
                            existData={existData}
                            userDetail={userDetail}
                            fieldNo={`${index}`} 
                            item={item}
                            fieldActions={fieldActions}
                            editingIndex={editingIndex}
                            setEditingIndex={setEditingIndex}
                            onVerifiedChange={handleVerifiedChange}
                            onCommentChange={handleCommentChange}
                            onUpdateSubmit={handleUpdateSubmit}
                            updatedFields={updatedFields} 
                            isValidationActive={isValidationActive}
                            hasValidationError={validationErrors[`field_${index}`] || false}
                            fieldIndex={index}
                          />
                        )}
                    </div>}
                    <div className='col-4 d-flex p-2 gap-2 flex-column flex-lg-row align-items-center justify-content-center'>
                      {!(
                          item.fieldNo === '01.' ||
                          item.fieldNo === '02.' 
                        ) && (
                      <div className='border rounded-3 ps-2'>
                        <OverlayTrigger
                            placement="bottom"
                            overlay={
                              <Tooltip >
                                See the edit history for this field
                              </Tooltip>
                            }
                          >
                            <i className="feather feather-info pe-2"></i>
                          </OverlayTrigger>
                        {/* <button
                          className='btn btn-light rounded-3 ms-2'
                          
                          onClick={() =>
                            handleViewLogClick((item.response.find((r) => r?.fieldName)?.fieldName)? (item.response.find((r) => r?.fieldName)?.fieldName) : (item.response.find((r) => r?.responseVal)?.responseVal) )
                          }
                        >
                          View Log
                        </button> */}
                        {(() => {
        
        const fieldName = item.response.find(r => r?.fieldName)?.fieldName;
        const annexureField = existData?.annexureOne?.[fieldName];

      
        // const hasTransaction = annexureField?.transaction && annexureField.transaction.length > 0;
        const hasValidTransaction =
          annexureField?.transaction?.some(
            (txn) =>
              ( txn?.comment.trim() !== "")
          ) ?? false;

        return (
          <button
            className={`btn rounded-3 ms-2 ${hasValidTransaction ? "btn-primary" : "btn-light"}`}
            onClick={() =>
              handleViewLogClick(
                fieldName
                  ? fieldName
                  : (item.response.find((r) => r?.responseVal)?.responseVal)
              )
            }
          >
            View Log
          </button>
        );
      })()}
                      </div>
                      )}
                    </div>
                    </div>
                  </div>

                {/* UPDATE SECTION */}
                {editingIndex === index && (
                  <div className="d-flex flex-column border-top border-secondary bg-white p-3">
                    <h4 className='border-bottom border-3 border-success mb-3'>Edit Values and Comment</h4>

                    {/* File Inputs */}
                    <div className="d-flex gap-3 flex-wrap mb-3">
                      {item.response
                        .filter(r =>  r.responseType === "button")
                        .map((r, fileIdx) => (
                          <div key={fileIdx} className="d-flex flex-column w-25">
                            <label className="fw-semibold mb-1">{r.responseName}</label>
                            <input 
                              className='form-control w-75' 
                              type='file'  
                              onChange={async(e) => {
                               const response = await  handleFileChange(e, `${r.fieldName}`);
                                // Update the field action with file data
                               
                                
                                if (e.target.files && e.target.files[0] && response) {
                                  
                                    const updatedDocId=response;

                                    handleUpdateData(index, {
                                      ...fieldActions[index]?.updateData,
                                      [r.fieldName]: {
                                        docId: updatedDocId, 
                                        documentName: r.responseVal,
                                        fileName:e.target.files[0].name
                                      }
                                    });
                                }
                              }}
                              name={`${r.responseVal}`}  
                              accept=".pdf, .jpeg, .jpg, application/pdf, image/jpeg" 
                              id='uploadPlan' 
                              onBlur={handleBlur}
                            />
                          </div>
                        ))}
                    </div>

                    {/* Other Input Types */}
                    <div className="d-flex gap-3 flex-wrap mb-3">
                      {item.response
                        .filter(r =>
                          r.responseType !== "file" &&
                          r.responseType !== "button"
                        )
                        .map((r, inputIdx) => {
                          const inputKey = `${index}_${inputIdx}`;
                          const label = r.responseName;

                          switch (r.responseType) {
                            case "input":
                              return (
                                <div key={inputKey} className="d-flex flex-column w-25">
                                  <label className="fw-semibold mb-1">{label}</label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter value"
                                    name={`${r.responseVal}`}
                                    value={fieldActions[index]?.updateData?.[r.responseVal] || ""}
                                    onChange={(e) => {
                                      handleInputChange(e)
                                      handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              );

                            case "percentage":
                              return (
                                <div key={inputKey} className="d-flex flex-column w-25">
                                  <label className="fw-semibold mb-1">{label}</label>
                                  <input
                                    type='text'
                                    inputMode='decimal'
                                    className="form-control"
                                    placeholder="0 - 100"
                                    min="0"
                                    max="100"
                                    value={fieldActions[index]?.updateData?.[r.responseVal] || ""}
                                    onChange={(e) => {
                                      const value = e.target.value;
                                      if (!/^\d{0,3}(\.\d{0,2})?$|^\d+\.$/.test(value)) return;
                                      const num = parseFloat(value);
                                      if (!isNaN(num) && num > 100) return;
                                      handleInputChange(e)
                                      handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: value
                                      });
                                    }}
                                    name={`${r.responseVal}`}
                                  />
                                </div>
                              );

                            case "radio":
                              return (
                                <div key={inputKey} className="d-flex flex-column w-25">
                                  <label className="fw-semibold mb-1">{label}</label>
                                  <label>
                                    <input
                                      type="radio"
                                name={`${r.responseVal}`}
                                      value="yes"
                                      checked={fieldActions[index]?.updateData?.[r.responseVal] === "yes"}
                                      onChange={(e) => {
                                        handleInputChange(e)
                                        handleUpdateData(index, {
                                          ...fieldActions[index]?.updateData,
                                          [r.responseVal]: e.target.value
                                        });
                                      }}
                                    />{" "}
                                    Yes
                                  </label>
                                  <label>
                                    <input
                                      type="radio"
                                   name={`${r.responseVal}`}
                                      value="no"
                                      checked={fieldActions[index]?.updateData?.[r.responseVal] === "no"}
                                      onChange={(e) => {
                                        handleInputChange(e)
                                        handleUpdateData(index, {
                                          ...fieldActions[index]?.updateData,
                                          [r.responseVal]: e.target.value
                                        });
                                      }}
                                    />{" "}
                                    No
                                  </label>
                                </div>
                              );

                            case "select":
                              return (
                                <div key={inputKey} className="d-flex flex-column w-25">
                                  <label className="fw-semibold mb-1">{label}</label>
                                  <CommonSelect
                                    className="form-select"
                                     options={
                                                            [
                                                              { label: "A", value: "A" },
                                                              { label: "B", value: "B" },
                                                              { label: "C", value: "C" },
                                                              { label: "D", value: "D" },
                                    
                                                            ]
                                                          } // Adjust as needed
                                    placeholder="Select option"
                                   name={`${r.responseVal}`}
                                    // value={fieldActions[index]?.updateData?.[r.responseVal] || ""}
                                 onChange={(option) => {
                                      handleInputChange({
                                        target: {
                                          name: r.responseVal,
                                          value: option.value
                                        }
                                      } as any
                                      )
                                      handleUpdateData(index, {
                                        ...fieldActions[index]?.updateData,
                                        [r.responseVal]: option.value
                                      });
                                    }}
                                  />
                                </div>
                              );

                            default:
                              return null;
                          }
                        })}
                    </div>
                  </div>
                )}

              </React.Fragment>
              )
            })}
 
          </div>
        </div>
        <div className="d-flex justify-content-end mb-3 me-5">
          <button className="btn btn-info " onClick={handleNextClick}>Next</button>
        </div>

      </div>
      </div>

      {showLogOverlay && (
  <div
    className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
    style={{ backgroundColor: "rgba(0, 0, 0, 0.6)", zIndex: 1055 }}
  >
    <div
      className="bg-white p-4 rounded shadow position-relative overflow-auto"
      style={{ minWidth: "70%", maxHeight: "90%", maxWidth: "800px" }}
    >
      <button
        className="position-absolute top-0 end-0 m-3 btn-close"
        onClick={handleCloseOverlay}
      />

      <div className="d-flex align-items-center gap-2 mb-3">
        <i className="ti ti-history"></i>
        <h4 className="mb-0">Change History - {formFieldDataP1.find(f => f.fieldName === logFieldKey)?.fieldLabel}</h4>
      </div>

      {/* Transaction Section */}
      {transactionData?.length > 0 && (
        <div className="mt-4">
          <div className="d-flex align-items-center gap-2 mb-3">
            <i className="ti ti-report"></i>
            <h5 className="mb-0">Transaction History</h5>
          </div>

          {transactionData.map((txItem, idx) => (
            <div key={idx} className="mb-4">
              <div className="badge bg-info mb-2"> {formFieldDataP1.find(f => f.fieldName === txItem.key)?.fieldLabel || txItem.key}</div>

              {txItem.data.length === 0 ? (
                <div className="text-muted">No transaction found.</div>
              ) : (
                txItem.data.map((entry, i) => (
                  <div
                    key={i}
                    className="border-start border-info border-3 p-3 mb-3 bg-light-subtle rounded"
                  >
                    <div className="d-flex justify-content-between align-items-center mb-2">
                      <strong>Modified By:   {(() => {
                                                          const role = roleOptions.find(
                                                            (option) => option.value === entry.transactionBy
                                                          );
                                                         
                                                          return role?.label || "Unknown";
                                                        })()}</strong>
                      <small className="text-muted">📅 {entry.createdAt || "-"}</small>
                    </div>
                 {entry.oldValue.length > 0 && entry.newValue.length > 0 &&   <div className="d-flex align-items-center gap-2 mb-2">
                      <span className="text-danger">Old Data:</span>
                      <div className="d-flex flex-column gap-1">
                          {Array.isArray(entry.oldValue) ? (
                            entry.oldValue.map((item, i) =>
                              typeof item === "object" && item.fieldType === "doc" ? (
                                <div key={i} className="d-flex align-items-center gap-2">
                                  <span className="badge bg-secondary">{responseMap[item?.fieldName]}</span>
                                  <Link
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#apmc_modal"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => setSelectedDocId(item.fieldValue)}
                                  >
                                    <i className="ti ti-eye"></i> View Document
                                  </Link>
                                </div>
                              ) : (
                                <span key={i} className="badge bg-danger-subtle text-danger">
                                  {typeof item === "object" ? item.fieldValue : item}
                                </span>
                              )
                            )
                          ) : (
                            <span className="badge bg-danger-subtle text-danger">{entry.oldValue.fieldValue}</span>
                          )}
                        </div>
                      <i className="ti ti-arrow-right"></i>
                      <span className="text-danger">Updated Data:</span>

                       <div className="d-flex flex-column gap-1">
                          {Array.isArray(entry.newValue) ? (
                            entry.newValue.map((item, i) =>
                              typeof item === "object" && item.fieldType === "doc" ? (
                                <div key={i} className="d-flex align-items-center gap-2">
                                  <span className="badge bg-success">{responseMap[item?.fieldName]}</span>
                                  <Link
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#apmc_modal"
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => setSelectedDocId(item.fieldValue)}
                                  >
                                    <i className="ti ti-eye"></i> View Document
                                  </Link>
                                </div>
                              ) : (
                                <span key={i} className="badge bg-danger-subtle text-danger">
                                  {typeof item === "object" ? item.fieldValue : item}
                                </span>
                              )
                            )
                          ) : (
                            <span className="badge bg-danger-subtle text-danger">{entry.newValue.fieldValue}</span>
                          )}
                        </div>
                    </div>}
                    <div className="d-flex align-items-center gap-2 mb-2">
                      <span className="text-muted">Status:</span>
                      <span className="badge bg-warning-subtle text-dark fs-14">
                        {entry.status}
                      </span>
                    </div>
                    {/* Show verification status if available */}
                    {entry.isVerified !== undefined && (
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <span className="text-muted">Verified:</span>
                        <span className={`badge ${entry.isVerified ? 'bg-success' : 'bg-secondary'}`}>
                          {entry.isVerified ? 'Yes' : 'No'}
                        </span>
                      </div>
                    )}
                    {entry.comment && (
                      <div className="bg-primary-subtle text-dark rounded p-2 d-flex align-items-start gap-2">
                        <i className="ti ti-message mt-1"></i>
                        <span>{entry.comment}</span>
                      </div>
                    )}
                  </div>
                ))
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  </div>
)}

      <SingleView docId={selectedDocId}  type="Scheme"/>

    </>
  )
}

export default DistP1